module.exports = __webpack_public_path__ + "static/media/_st-barts.72ef2ba8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_st-barts.svg
// module id = 2354
// module chunks = 7